<template>
<div>
  <el-dialog
    title="Upload from CSV"
    :visible.sync="upload_visible"
    >
    <el-upload
        id="data_file"
        drag
        :on-success="afterSuccessfulUpload"
        :on-remove="afterRemove"
        action="/api/uploads">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
    </el-upload>
    <el-checkbox v-model="form.overwrite">Overwrite existing map pairs</el-checkbox>
    <el-button type="primary" v-on:click="startImport" id="data_start" >Load CSV</el-button>
  </el-dialog>
  <el-dialog
      title="Edit To >> From"
      :visible.sync="show_edit_filter"
      width="75%"
  >
    <FormManager
        @save="save"
        @cancelDialog="cancelDialog"
        @onModify="onModify"
        :initialFormValues="selected_map_pair_values"
        :events="events"
        prettyEndPoint="/api/maps/pairs/pretty" />
  </el-dialog>
  <p>Mapping pairs are applied in order (the first match is applied).</p>
  <el-button style="margin-bottom:20px;" @click="show_upload">Upload CSV</el-button>
  <el-button style="margin-bottom:20px;" @click="download">Download CSV</el-button>
  <el-input style="margin-left:10px;display:inline-block;width:40%" placeholder="value to test" v-model="test_value"></el-input>
  <el-button @click="test_a_value">Test Value</el-button>

  <div v-if="match_id">
    <div v-if="match.result.matched" style="background-color: #67C23A;padding:20px;color:white;">
      <h4>Matched</h4>
      <ul>
        <li>Tested Value: <strong>{{test_value}}</strong></li>
        <li>Matched On: <strong>{{match.result.match.from}}</strong></li>
        <li>Resulting Value: <strong>{{match.result.result}}</strong></li>
      </ul>
      {{match.eval_info}}
    </div>
    <div v-else style="background-color: #F56C6C;padding:20px;color:white;">
      <h4>NO Match</h4>
    </div>
  </div>

  <el-table-draggable handle=".draggable" @drop="handleReorder" v-if="have_data">
    <el-table
        :data="map.map_pair_list.map_pairs"
        style="width: 100%">
      <el-table-column
          v-for = "column in columns"
          v-bind:label = column.label
          v-bind:prop = column.prop
          v-bind:width = column.width
      >
        <template slot-scope="scope">
          <div class="draggable" >
            <div  @mouseenter="showInsert(scope.row.id)">
              <span v-if="column.prop.toLowerCase() === 'delete'">
                  <el-button type="link" @click="delete_row(scope.row.id)" icon="el-icon-delete"></el-button>
              </span>
              <span v-else-if="column.prop.toLowerCase() === 'edit'">
                  <el-button  class="ss-button" @click="edit(scope.row.id)" icon="el-icon-edit"></el-button>
              </span>
              <span v-else-if="column.prop.toLowerCase() === 'order'" >
                  <el-button :type="match_id===scope.row.id ? 'success' : 'plain'" @click="setEditableInplace(scope.row.id, column.prop,scope.row[column.prop])"><i class="el-icon-sort"></i>{{ scope.row[column.prop] }}</el-button>
                  <span v-if="scope.row.showInsert" style="font-size:10px;" @click="insertRule(scope.row[column.prop])">insert rule</span>

              </span>
              <span v-else-if="column.prop.toLowerCase() === 'from'">
                {{scope.row[column.prop]}} →
              </span>
              <span v-else>{{scope.row[column.prop]}}</span>
            </div>
          </div>

        </template>
      </el-table-column>
    </el-table>
  </el-table-draggable>
  <el-button @click="add" :type="match_id===-1 ? 'danger': 'default'" icon="el-icon-plus" style="margin-top:10px;margin-left:10px;"></el-button>
</div>
</template>

<script>
import ElTableDraggable from "element-ui-el-table-draggable";

export default {
  name: "MapEditor",
  props: ['map_id'],
  data() {
    return {
      test_value: '',
      match: null,
      match_id: null,
      upload_visible: false,
      form: {
        overwrite: false,
        upload_file: '',
      },
      map: null,
      have_data: false,
      show_edit_filter: false,
      selected_map_pair_values: null,
      events: {
        save: {
          label: "Save",
          event: "save"
        },
        cancel: {
          label: "Cancel",
          event: "cancel"
        }
      },
      columns: [
        {
          label: 'order',
          prop: 'order',
          width: 80
        },
        {
          label: 'FROM →',
          prop: 'from',
          width: 120
        },
        {
          label: 'TO',
          prop: 'to',
          width: 120
        },
        {
          label: 'edit',
          prop: 'edit',
          width: 80
        },

        {
          label: 'delete',
          prop: 'delete',
          width: 80
        },
      ]
    }
  },
  mounted() {
    this.get_pairs()
  },
  components: {ElTableDraggable},
  methods: {
    showInsert(rowId) {
      console.log('in showInsert with ' + rowId)
      this.map.map_pair_list.map_pairs = this.map.map_pair_list.map_pairs.map((pair) => {
        pair.id === rowId ? pair.showInsert = true : pair.showInsert = false
        return pair
      })
      console.log('exiting showInsert with ' + rowId)
    },
    test_a_value() {
      console.log(this.test_value)
      this.match = null
      this.match_id = null
      axios.post('/api/maps/' + this.map_id + '/test', {
        test_value: this.test_value,
      }).then(response => {
        this.match = response.data
        this.match_id = response.data.result.id
        if (!this.match_id) this.match_id = -1
        console.log(response.data)
      }).catch(error => {
            console.log('oops testing value')
            console.log(error.response)
      })
    },
    download() {
      window.open('/api/maps/pairs/download/' + this.map_id,"_blank")
    },
    show_upload() {
      this.upload_visible = true
    },
    startImport() {
      axios.post('/api/maps/pairs/upload/' + this.map_id, {
        extent_id: this.selected_extent,
        overwrite: this.form.overwrite,
        upload_file: this.form.upload_file
      }).then(response => {
        this.get_pairs()
        this.upload_visible = false
      }).catch(error => {
        console.log('oops problem starting import')
        console.log(error.response)
      })
      //
    },
    get_pairs() {
      axios.get('/api/maps/' + this.map_id)
          .then(response => {
            this.map = response.data
            this.map.map_pair_list.map_pairs.map((pair) => {
              pair.showInsert = false
              return pair
            })
            this.have_data = true
          })
          .catch(error => {
            console.log('could not load map')
          })
    },
    async handleReorder() {
      try {
        await axios.patch(`/api/maps/pairs/${this.map.map_pair_list.id}/order`, {
          mapPairs: this.map.map_pair_list.map_pairs,
        })
        this.get_pairs()
      } catch (error) {
        console.error(error);
      }
    },
    async delete_row(row_id) {
      try {
        await axios.delete(`/api/map-pairs/${row_id}`);
        this.$delete(this.map.map_pair_list.map_pairs, this.map.map_pair_list.map_pairs.findIndex((pair) => pair.id === row_id));
      } catch (error) {
        console.error(error);
      }
    },
    edit(row_id) {
      console.log('here comes the row id')
      console.log(row_id)
      this.selected_map_pair_values = this.map.map_pair_list.map_pairs.filter(obj => {return obj.id === row_id})[0]
      console.log('have existing map pair values')
      console.log(this.selected_map_pair_values)
      this.show_edit_filter = true
    },
    save(values) {
      console.log('got save values:')
      console.log(values)
      axios.post('/api/maps/pairs/' + this.map.id, {
        values: values
      }).then(response => {
        this.get_pairs()
        this.show_edit_filter = false
        this.selected_map_pair_values = null
        console.log('saved/updated map pair')
      })
      .catch(error => {
        console.log('could not save/update map pair')
      })
    },
    onModify() {

    },
    cancelDialog() {

    },
    insertRule(order) {
      let new_order = order>=65535 ? 65535 : order+1
      this.selected_map_pair_values = {order: new_order}
      this.show_edit_filter = true
    },
    add() {
      this.selected_map_pair_values = null
      this.show_edit_filter = true
    },
    afterSuccessfulUpload(response) {
      this.error_no_upload = false
      this.form.upload_file = response
    },
    afterRemove() {
      this.form.upload_file = ''
    },

  }
}
</script>

<style scoped>

</style>